import {
    StepTypeDetailed, OrderStepType,
} from 'app/enums/label.enums'

import {
    StepData,
} from '../../createManuallyForm.types'

const mapOrderSteps: StepData[] = [
    {
        title: 'Road',
        stepType: OrderStepType.ROAD,
        stepTypeDetailed: StepTypeDetailed.ROAD_INTERNAL,
        imgSrc: 'assets/images/orderSteps/road.svg',
    },
    {
        title: 'Road Pick-Up',
        stepType: OrderStepType.ROAD,
        stepTypeDetailed: StepTypeDetailed.ROAD_INTERNAL_PICKUP,
        imgSrc: 'assets/images/orderSteps/road_internal_pickup.svg',
    },
    {
        title: 'Road Delivery',
        stepType: OrderStepType.ROAD,
        stepTypeDetailed: StepTypeDetailed.ROAD_INTERNAL_DELIVERY,
        imgSrc: 'assets/images/orderSteps/road_internal_delivery.svg',
    },
    {
        title: 'Sea',
        stepType: OrderStepType.SEA,
        stepTypeDetailed: StepTypeDetailed.SEA_INTERNAL,
        imgSrc: 'assets/images/orderSteps/sea.svg',
    },
    {
        title: 'Sea Road',
        stepType: OrderStepType.SEA,
        stepTypeDetailed: StepTypeDetailed.SEA_ROAD_INTERNAL,
        imgSrc: 'assets/images/orderSteps/sea_road.svg',
    },
    {
        title: 'Air',
        stepType: OrderStepType.AIR,
        stepTypeDetailed: StepTypeDetailed.AIR_INTERNAL,
        imgSrc: 'assets/images/orderSteps/air.svg',
    },
    {
        title: 'Air Road',
        stepType: OrderStepType.AIR,
        stepTypeDetailed: StepTypeDetailed.AIR_ROAD_INTERNAL,
        imgSrc: 'assets/images/orderSteps/air_road.svg',
    },
    {
        title: 'Event',
        stepType: OrderStepType.EVENT,
        stepTypeDetailed: StepTypeDetailed.EVENT_EVENT,
        imgSrc: 'assets/images/orderSteps/event.svg',
    },
    {
        title: 'Road to Event',
        stepType: OrderStepType.ROAD,
        stepTypeDetailed: StepTypeDetailed.ROAD_TO_EVENT,
        imgSrc: 'assets/images/orderSteps/road_to_event.svg',
    },
    {
        title: 'Road From Event',
        stepType: OrderStepType.ROAD,
        stepTypeDetailed: StepTypeDetailed.ROAD_FROM_EVENT,
        imgSrc: 'assets/images/orderSteps/road_from_event.svg',
    },
]

export default mapOrderSteps
